import { render } from "./Refuse.vue?vue&type=template&id=736482e4"
import script from "./Refuse.vue?vue&type=script&lang=js"
export * from "./Refuse.vue?vue&type=script&lang=js"

import "./Refuse.vue?vue&type=style&index=0&id=736482e4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/Type/Refuse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "736482e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('736482e4', __exports__)) {
    api.reload('736482e4', __exports__)
  }
  
  module.hot.accept("./Refuse.vue?vue&type=template&id=736482e4", () => {
    api.rerender('736482e4', render)
  })

}


export default __exports__